exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected[data-v-6d4c2b56]{color:#d3d3d3}.dropbtn[data-v-6d4c2b56]{cursor:pointer}.dropdown[data-v-6d4c2b56]{position:relative;display:inline-block}.dropdown-content[data-v-6d4c2b56]{display:none;position:absolute;background-color:#f9f9f9;width:600px;box-shadow:0 8px 16px 0 rgba(0,0,0,.2);z-index:1;left:110px;top:-110px}.dropdown:hover .dropdown-content[data-v-6d4c2b56]{display:block}.dropdown:hover .dropbtn[data-v-6d4c2b56]{background-color:#d3d3d3}.modal-content[data-v-6d4c2b56]{position:absolute;z-index:1;padding-top:200px;left:4px;top:-5px;background-color:#fefefe;margin:auto;padding:0;border:1px solid #888;max-height:60vh;overflow:scroll}button[data-v-6d4c2b56]{padding:12px;border:1px solid #ccc;border-radius:4px;margin-top:6px;margin-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d4c2b56","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/officesInputForm.vue
// module id = 177
// module chunks = 0